"use client";

import {SDivider} from "@/components/atoms/divider";
import {Section} from "@/components/atoms/sections";
import {NeutralMessage, Title, TitleLabel} from "@/components/atoms/typographies";
import {AsideLayout, ContentLayout} from "@/components/molecules/layouts";
import {TabItem, TabsHeader} from "@/components/molecules/tabs";
import {useState} from "react";
import {LodgingPrices} from "./_components/lodgings";
import {ObjectType} from "@/lib/types";

type T = TabItem & { object_type: ObjectType }
const items: T[] = [
  {
    label: "Locations",
    object_type: "lodgings"
  },
  // {
  //   label: "Evènements",
  //   object_type: "events"
  // },
  // {
  //   label: "Pages",
  //   object_type: "pages"
  // },
];
export default function PageView(props: any) {
  const [selectedTab, setSelectedTab] = useState(0);

  return (<>
    <ContentLayout>
      <Title>Tarifs des options</Title>
      <TitleLabel>Consultez les tarifs des options et services</TitleLabel>
      <SDivider/>
      <Section>
        <TabsHeader items={items} selectedTab={selectedTab} onChange={setSelectedTab}/>
        <div className="p-2">
          {items[selectedTab] && <LodgingPrices objectType={items[selectedTab].object_type}/>}
        </div>
        <NeutralMessage className="text-center text-sm">Les tarifs appliqués sont ceux en vigueur au jour de l’achat
          d’une ou des option(s) payante(s) par
          l’Annonceur.<br/>Computing Square se réserve la possibilité de modifier ses prix à tout
          moment.</NeutralMessage>
      </Section>
    </ContentLayout>
    <AsideLayout>

    </AsideLayout>
  </>);
}
